import { SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const SkeletonBarChartLoader = styled(SkeletonLoader)`
  width: auto;
`;
